import { render, staticRenderFns } from "./NewRirekishoLicenseCard.vue?vue&type=template&id=82b8967c"
import script from "./NewRirekishoLicenseCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewRirekishoLicenseCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports